import { getColor } from 'common/constants/_colors';
import styled from 'styled-components';
import { Flex } from './base/layout-components';

export const LabelStyled = styled(Flex)`
  background: ${getColor('white')};
  border: 1px solid ${getColor('botticelli')};
  border-radius: 4px;
  padding-left: 0.7rem;
  min-height: 2.2rem;
  font-size: 1rem;
  flex-wrap: wrap;
  width: fit-content;
  > span {
    color: ${getColor('osloGray')};
    text-transform: uppercase;
    padding-right: 0.5rem;
  }
  .MuiChip-root {
    margin: 0.45rem 0.5rem 0.45rem 0;
    font-size: 1rem;
    height: 2.2rem;
    color: ${getColor('shark')};
    border: 1px solid ${getColor('botticelli')};
    background: ${getColor('white')} !important;
  }
`;

export const TeamIcon = styled(Flex)`
  width: 1.6rem;
  height: 1.6rem;
  ${({ teamColor }) => `background-color: ${teamColor ? teamColor : 'green'}`};
  border-radius: 30px;
  justify-content: center;
`;
